export default __webpack_public_path__ + "static/media/menu.5a8c3ac4.svg";